import React from 'react';

import Logo from 'dpl/components/Logo';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import { usePuppyData } from '../hooks/usePuppyData';
import RequestInfoButton from './RequestInfoButton';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function PageHeader() {
  const { puppy, breeder, litter } = usePuppyData();

  if (IS_LT_MD) return null;

  return (
    <header className="PageHeader bg-white bb b--subtle-gray mb5 z-99999 sticky top-0">
      <div className="container-xxl pv3">
        <div className="flex justify-between items-center">
          <a href="/" className="Header__logo primary" aria-label="homepage">
            <Logo />
          </a>
          <div className="flex items-center">
            <div>
              {puppy.reserved ? (
                <button
                  className="flex items-center justify-center ph8 pv3 br2 ba fw-medium font-16 bg-red white"
                  type="button"
                  disabled
                >
                  Reserved
                </button>
              ) : (
                <RequestInfoButton
                  breederProfileId={breeder.id}
                  litterId={litter.id}
                  puppyId={puppy.id}
                  inquirySource={ANALYTICS_VIEWS.PUPPY_PROFILE}
                  variants={{
                    base: 'flex items-center justify-center ph8 pv3 br2 ba fw-medium font-16',
                    primary: 'bg-blue-500 white'
                  }}
                  analytics={{
                    view: ANALYTICS_VIEWS.PUPPY_PROFILE,
                    view_feature: ANALYTICS_VIEW_FEATURES.REQUEST_INFO_BUTTON,
                    view_feature_location:
                      ANALYTICS_VIEW_FEATURE_LOCATIONS.PAGE_HEADER
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
